import { navigateTo, routeEntries } from '../router'
import { scrollTopButtonTemplate } from './infiniteListTemplates'
import { navItemTemplate, navTemplate } from './navTemplates'
import { closeOverlay } from './Overlay'
import { overlayBackButtonTemplate } from './overlayTemplates'

const NAV_TOOLTIP_DURATION_MS = 900

export function renderNav(): string {
	const itemsHtml = routeEntries
		.filter(([, route]) => route.isProtected)
		.map(([path, route]) => navItemTemplate(path, route.title, route.icon))
		.join('')

	return navTemplate(
		itemsHtml,
		overlayBackButtonTemplate(),
		scrollTopButtonTemplate(),
	)
}

export function bindNavEvents(): void {
	const navList = document.querySelector<HTMLElement>('.nav-list')
	if (!navList) return
	navList.addEventListener('click', handleNavClick)
}

function handleNavClick(event: MouseEvent): void {
	if (
		event.button !== 0 ||
		event.metaKey ||
		event.ctrlKey ||
		event.shiftKey ||
		event.altKey
	)
		return
	const target = event.target as HTMLElement | null
	const link = target?.closest<HTMLAnchorElement>('a[data-route]')
	if (!link) return

	event.preventDefault()
	const path = link.dataset.route
	if (!path) return
	if (window.location.pathname.replace(/\/+$/, '') === path) {
		if (
			document
				.getElementById('app-root')
				?.classList.contains('overlay-active')
		) {
			closeOverlay()
		} else {
			window.scrollTo({
				top: 0,
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)')
					.matches
					? 'instant'
					: 'smooth',
			})
		}
		return
	}

	showTooltip(link)
	window.history.pushState({}, '', path)
	void navigateTo(path)
}

function showTooltip(link: HTMLAnchorElement): void {
	link.classList.add('show-tooltip')
	window.setTimeout(() => {
		link.classList.remove('show-tooltip')
	}, NAV_TOOLTIP_DURATION_MS)
}
